import { useEffect, useRef } from 'react';
import createMrktNavigationBrowser from 'spotify-event-definitions/events/createMrktNavigationBrowser';
import { PageId } from '../PageId';
import { logGabitoEvent } from '../logger';

type Props = {
  pageId: PageId | null;
  creatorUri: string | null;
  organizationUri: string | null;
};

export function useNavigationLogger(props: Props) {
  const prevPageId = useRef<PageId | null>(null);
  const prevPageUri = useRef<string | null>(null);

  const { pageId, creatorUri, organizationUri } = props;

  useEffect(() => {
    const toPageUri = window.location.href;
    const fromPageId = prevPageId.current;
    const fromPageUri = prevPageUri.current;

    prevPageId.current = pageId;
    prevPageUri.current = toPageUri;

    if (pageId) {
      logNavigation({
        toPageId: pageId,
        toPageUri,
        fromPageId,
        fromPageUri,
        creatorUri,
        organizationUri,
        navigationalRootId: null,
      });
    }
  }, [pageId, creatorUri, organizationUri]);
}

type NavigationEvent = {
  toPageId: PageId;
  toPageUri: string;
  fromPageId: PageId | null;
  fromPageUri: string | null;
  creatorUri: string | null;
  organizationUri: string | null;
  navigationalRootId: PageId | null;
};

function logNavigation({
  toPageId,
  toPageUri,
  fromPageId,
  fromPageUri,
  creatorUri,
  organizationUri,
  navigationalRootId,
}: NavigationEvent) {
  logGabitoEvent(
    createMrktNavigationBrowser({
      to_page_id: toPageId,
      to_page_uri: toPageUri,
      from_page_id: fromPageId,
      from_page_uri: fromPageUri,
      navigational_root_id: navigationalRootId,
      creator_uri: creatorUri,
      organization_uri: organizationUri,
    }),
  );
}
